export const X1StyleXDarkTheme = {
  "nav-bar-background": "#000000",
  wash: "#050505",
  "web-wash": "#050505",
  "primary-text": "#FFFFFF",
  "primary-accent": "#7928CA",
  "border-line": "#333333",
  "card-corner-radius": "24px",
  "media-inner-border": "rgba(255, 255, 255, 0.1)",
  divider: "#333333",
  "primary-gradient":
    "linear-gradient(135deg, #FF0080 0%, #7928CA 50%, #FF4D4D 100%)",
  "secondary-gradient": "linear-gradient(135deg, #007CF0 0%, #00DFD8 100%)",
  "bg-gradient":
    "radial-gradient(circle at 50% 0%, rgba(121, 40, 202, 0.25), transparent 70%), radial-gradient(circle at 100% 0%, rgba(255, 0, 128, 0.15), transparent 50%)",
  "surface-glass": "rgba(255, 255, 255, 0.05)",
  "surface-glass-strong": "rgba(30, 30, 30, 0.8)",
  "shadow-sm":
    "0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)",
  "shadow-md":
    "0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -2px rgba(0, 0, 0, 0.3)",
  "shadow-lg":
    "0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.2)",
  "shadow-neon": "0 0 25px rgba(121, 40, 202, 0.5)",
  "glow-border": "rgba(255, 255, 255, 0.15)",
  "text-secondary": "#A1A1AA",
  "timeline-line-bg":
    "linear-gradient(135deg, #FF0080 0%, #7928CA 50%, #FF4D4D 100%)",
  "timeline-dot-shadow": "0 0 15px rgba(121, 40, 202, 0.5)",
  "profile-border": "rgba(255, 255, 255, 0.1)",
  "profile-shadow": "0 0 40px rgba(121, 40, 202, 0.6)",
  "loading-border-color": "#7928CA",
};
